var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"styles tabs"},_vm._l((_vm.styles),function(style){return _c('a',{key:style.title,staticClass:"style",class:{active: style.active},on:{"click":function($event){_vm.activate(style)}}},[_vm._v(_vm._s(style.title))])}))}
var staticRenderFns = []

export { render, staticRenderFns }